// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.iframe-wrapper[data-v-668b3cfb]{width:100%}.iframe-wrapper[data-v-668b3cfb] iframe{width:100%;border:0}.promoText[data-v-668b3cfb]{color:var(--text-primary)}@media (min-width:768px){.promoText[data-v-668b3cfb]{margin-top:2.4rem;margin-bottom:4.8rem}}@media (max-width:767px){.promoText[data-v-668b3cfb]{margin-top:1.6rem;margin-bottom:3.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
